export default __webpack_public_path__ + "static/media/tele-plan-carousel-2-tata.6a55f287.png";